import React from 'react';

import { G, Image, Path, StyleSheet, Svg, Text, View } from '@react-pdf/renderer';

interface IRoundDiagramImageProps {
  imgSrc?: string;
  length: number;
  text?: string;
  colors: string[];
}

export const RoundDiagramImage: React.FC<IRoundDiagramImageProps> = ({ imgSrc, text, length, colors }) => {
  return (
    <View style={styles.imageContainer}>
      <Svg width="260" height="260" viewBox="44 -12 260 260">
        <G>
          {length === 1 && (
            <G>
              <Path
                fill={colors[1]}
                d="M 119.98207675807483 29.500001825242066 A 88 88 0 0 1 120.07007675054453 205.49997209800145 L 120.04554988785394 174.69998186370094 A 57.2 57.2 0 0 0 119.98834989274863 60.30000118640734 Z"
              />
              <Path
                fill={colors[0]}
                d="M 119.98207675807483 205.49999817475793 A 88 88 0 0 1 119.8777697654497 29.500084887712745 L 119.9205503475423 60.300055177013284 A 57.2 57.2 0 0 0 119.98834989274863 174.69999881359266 Z"
              />
            </G>
          )}
          {length === 2 && (
            <G>
              <Path
                fill={colors[1]}
                d="M 119.98207675807483 29.500001825242066 A 88 88 0 0 1 207.99995600000366 117.41200001466666 L 177.1999714000024 117.44280000953333 A 57.2 57.2 0 0 0 119.98834989274863 60.30000118640734 Z"
              />
              <Path
                fill={colors[2]}
                d="M 208 117.5 A 88 88 0 0 1 120.07007675054453 205.49997209800145 L 120.04554988785394 174.69998186370094 A 57.2 57.2 0 0 0 177.2 117.5 Z"
              />
              <Path
                fill={colors[0]}
                d="M 119.98207675807483 205.49999817475793 A 88 88 0 0 1 119.8777697654497 29.500084887712745 L 119.9205503475423 60.300055177013284 A 57.2 57.2 0 0 0 119.98834989274863 174.69999881359266 Z"
              />
            </G>
          )}
          {length === 3 && (
            <G>
              <Path
                fill={colors[1]}
                d="M 119.98207675807483 29.500001825242066 A 88 88 0 0 1 196.14850686281883 73.39325558870578 L 169.49652946083225 88.83061613265876 A 57.2 57.2 0 0 0 119.98834989274863 60.30000118640734 Z"
              />
              <Path
                fill={colors[2]}
                d="M 196.19257552562874 73.46942613624756 A 88 88 0 0 1 196.23656799586948 161.45435928564046 L 169.55376919731515 146.07033353566632 A 57.2 57.2 0 0 0 169.5251740916587 88.8801269885609 Z"
              />
              <Path
                fill={colors[3]}
                d="M 196.19257552562874 161.53057386375244 A 88 88 0 0 1 120.07007675054453 205.49997209800145 L 120.04554988785394 174.69998186370094 A 57.2 57.2 0 0 0 169.5251740916587 146.1198730114391 Z"
              />
              <Path
                fill={colors[0]}
                d="M 119.98207675807483 205.49999817475793 A 88 88 0 0 1 119.8777697654497 29.500084887712745 L 119.9205503475423 60.300055177013284 A 57.2 57.2 0 0 0 119.98834989274863 174.69999881359266 Z"
              />
            </G>
          )}
          {length === 4 && (
            <G>
              <Path
                fill={colors[1]}
                d="M 119.98207675807483 29.500001825242066 A 88 88 0 0 1 182.18793595606184 55.23716500572149 L 160.4221583714402 77.02915725371896 A 57.2 57.2 0 0 0 119.98834989274863 60.30000118640734 Z"
              />
              <Path
                fill={colors[2]}
                d="M 182.25016768671358 55.299384062727796 A 88 88 0 0 1 207.99995600000366 117.41200001466666 L 177.1999714000024 117.44280000953333 A 57.2 57.2 0 0 0 160.46260899636383 77.06959964077306 Z"
              />
              <Path
                fill={colors[3]}
                d="M 208 117.5 A 88 88 0 0 1 182.31233716720283 179.63833467965515 L 160.50301915868184 157.88991754177584 A 57.2 57.2 0 0 0 177.2 117.5 Z"
              />
              <Path
                fill={colors[4]}
                d="M 182.25016768671358 179.7006159372722 A 88 88 0 0 1 120.07007675054453 205.49997209800145 L 120.04554988785394 174.69998186370094 A 57.2 57.2 0 0 0 160.46260899636383 157.93040035922695 Z"
              />
              <Path
                fill={colors[0]}
                d="M 119.98207675807483 205.49999817475793 A 88 88 0 0 1 119.8777697654497 29.500084887712745 L 119.9205503475423 60.300055177013284 A 57.2 57.2 0 0 0 119.98834989274863 174.69999881359266 Z"
              />
            </G>
          )}
          {length === 5 && (
            <G>
              <Path
                fill={colors[1]}
                d="M 119.98207675807483 29.500001825242066 A 88 88 0 0 1 171.68791762813981 46.2795031520656 L 153.5971464582909 71.20667704884264 A 57.2 57.2 0 0 0 119.98834989274863 60.30000118640734 Z"
              />
              <Path
                fill={colors[2]}
                d="M 171.759112269161 46.33122667132454 A 88 88 0 0 1 203.67008134443668 90.23615053197095 L 174.38555287388385 99.77849784578112 A 57.2 57.2 0 0 0 153.64342297495466 71.24029733636095 Z"
              />
              <Path
                fill={colors[3]}
                d="M 203.69730335432354 90.31983423129397 A 88 88 0 0 1 203.72444166691406 144.5964548892195 L 174.42088708349414 135.1126956779927 A 57.2 57.2 0 0 0 174.4032471803103 99.83289225034108 Z"
              />
              <Path
                fill={colors[4]}
                d="M 203.69730335432354 144.68016576870602 A 88 88 0 0 1 171.83025515107425 188.6169786406491 L 153.68966584819827 163.72603611642194 A 57.2 57.2 0 0 0 174.4032471803103 135.16710774965892 Z"
              />
              <Path
                fill={colors[5]}
                d="M 171.759112269161 188.66877332867546 A 88 88 0 0 1 120.07007675054453 205.49997209800145 L 120.04554988785394 174.69998186370094 A 57.2 57.2 0 0 0 153.64342297495466 163.75970266363905 Z"
              />
              <Path
                fill={colors[0]}
                d="M 119.98207675807483 205.49999817475793 A 88 88 0 0 1 119.8777697654497 29.500084887712745 L 119.9205503475423 60.300055177013284 A 57.2 57.2 0 0 0 119.98834989274863 174.69999881359266 Z"
              />
            </G>
          )}

          <Path
            fill={colors[1]}
            fillOpacity={0.05}
            d="M 120 39 A 88 79.45 0 0 1 120 197 L 120 174.7 A 57.2 57.2 90 0 0 120 60.3 Z"
          />
          <Path
            fill={colors[1]}
            fillOpacity={0.05}
            d="M 120 197 A 88 79.5 0 0 1 120 39 L 119.9 60.3 A 57.2 57.2 0 0 0 120 174.7 Z"
          />
        </G>
      </Svg>
      <View style={[styles.wrap, { backgroundColor: colors[0] }]}>
        {!!imgSrc && <Image src={imgSrc} style={styles.content} />}
        {!!text && (
          <View style={styles.textWrap}>
            <Text style={styles.text}>{text}</Text>
          </View>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  imageContainer: {
    width: '184px',
    height: '184px',
    minWidth: '184px',
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '-32px',
  },
  wrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '93px',
    maxHeight: '93px',
    minWidth: '93px',
    minHeight: '93px',
    border: '4px solid white',
    borderRadius: '50%',
    position: 'absolute',
    top: 45.5,
    left: 45.5,
  },
  content: {
    maxWidth: '88px',
    maxHeight: '88px',
    minWidth: '88px',
    minHeight: '88px',
    borderRadius: '50%',
    objectFit: 'cover',
  },
  textWrap: {
    width: '88px',
    height: '88px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    textAlign: 'center',
    fontSize: 11,
    fontWeight: 'bold',
    fontFamily: 'Noto',
  },
});
